import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

const AutocompleteChips = ({
  getIsChipWarning,
  maxLength,
  onChange,
  onClear,
  options,
  placeholder,
  selected,
  size = 'medium',
  titleKey,
}) => {
  const [open, setOpen] = useState(false);
  const onChangeHandler = (event, value) => {
    if (maxLength && value.length > maxLength) {
      return;
    }
    onChange(value);
  };
  const onClearHandler = () => onClear([]);
  const isDisabled = () => maxLength && selected.length === maxLength;
  const hasPlaceholder = () => (maxLength && selected.length < maxLength) || !maxLength;

  return (
    <Box sx={{ py: 1 }}>
      <Grid container>
        <Grid size={10}>
          <Autocomplete
            blurOnSelect
            disableClearable
            filterSelectedOptions
            forcePopupIcon={false}
            getOptionLabel={(option) => option[titleKey]}
            isOptionEqualToValue={(option, value) => option[titleKey] === value[titleKey]}
            multiple
            onChange={onChangeHandler}
            onClose={() => setOpen(false)}
            onOpen={() => !isDisabled() && setOpen(true)}
            open={open}
            options={options}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={hasPlaceholder() ? placeholder : null}
                variant="standard"
                slotProps={{
                  ...params.slotProps,

                  htmlInput: {
                    ...params.slotProps.htmlInput,
                    disabled: isDisabled(),
                  },

                  input: {
                    ...params.slotProps.input,
                    disableUnderline: true,
                  },
                }}
              />
            )}
            renderValue={(value, getItemProps) =>
              value.map((option, index) => (
                <Chip
                  {...getItemProps({ index })}
                  deleteIcon={
                    <CancelIcon
                      style={
                        getIsChipWarning(option)
                          ? {
                              backgroundColor: 'inherit',
                              color: 'white',
                            }
                          : {}
                      }
                    />
                  }
                  key={option}
                  label={option[titleKey]}
                  size={size}
                  sx={
                    getIsChipWarning(option)
                      ? {
                          backgroundColor: 'warning.main',
                          color: 'common.white',
                        }
                      : {}
                  }
                />
              ))
            }
            size={size}
            sx={isDisabled() ? { '& input': { display: 'none' } } : {}}
            value={selected}
          />
        </Grid>
        {selected.length > 0 && (
          <Grid container size={2} sx={{ alignItems: 'center' }}>
            <Grid>
              <Button color="primary" onClick={onClearHandler} startIcon={<CloseIcon />} sx={{ ml: 1 }}>
                <FormattedMessage {...messages.ClearButton} />
              </Button>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

AutocompleteChips.propTypes = {
  getIsChipWarning: PropTypes.func.isRequired,
  maxLength: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  placeholder: PropTypes.string.isRequired,
  selected: PropTypes.arrayOf(PropTypes.object).isRequired,
  size: PropTypes.oneOf(['medium', 'small']),
  titleKey: PropTypes.string.isRequired,
};

export default AutocompleteChips;
